
import { computed, defineComponent, getCurrentInstance } from 'vue';
import BlogLink from '@/components/docs-main/blog-pages/BlogLink.vue';

interface ContentWithChildren {
  children?: unknown[];
}

export default defineComponent({
  name: 'HowTo',
  components: {
    BlogLink,
  },
  metaInfo() {
    return {
      title: "HowTo's",
    };
  },
  setup() {
    const store = getCurrentInstance()?.proxy?.$store as
      | { getters: Record<string, unknown> }
      | undefined;

    const data = computed<ContentWithChildren>(() => {
      const content = store?.getters['getContent'] as ContentWithChildren | undefined;
      return content ?? { children: [] };
    });

    return {
      data,
    };
  },
});
